import { useState } from 'react';
import {
  PriceSelectionItemDto,
  TenderSupplier,
} from '@Features/MaterialRequest/requests/components/ComparisonSheet/ComparisonSheet.types';
import { TenderTotalAmountResponse } from '@Types/api/form/tenderRequest/TenderTotalAmountResponse';
import PriceBreakdown from '@Features/MaterialRequest/requests/components/ComparisonSheet/modals/PriceBreakdown/PriceBreakdown';

import styles from './approve-tab-mobile.module.css';
import RequestListMobile from './components/RequestListMobile/RequestListMobile';
import { ApproveFooter } from './components/FooterSection';

interface ApproveTabMobileProps {
  comparisonSheetSuppliers: TenderSupplier[];
  selectedSheetOffers: PriceSelectionItemDto[];
  totalAmountData: TenderTotalAmountResponse | undefined;
  handleOpenModal: () => void;
  handleBack: () => void;
}

const ApproveTabMobile: React.FC<ApproveTabMobileProps> = ({
  comparisonSheetSuppliers,
  selectedSheetOffers,
  totalAmountData,
  handleOpenModal,
  handleBack,
}) => {
  const [showPriceBreakdown, setShowPriceBreakdown] = useState<boolean>(false);

  const handlePriceBreakdown = (): void => {
    setShowPriceBreakdown(true);
  };

  return (
    <div>
      <div className={styles.overviewCaption}>Overview</div>
      <RequestListMobile
        vendors={comparisonSheetSuppliers}
        dataSource={selectedSheetOffers}
        context="comparison-screen"
      />
      <div className={styles.footerSection}>
        <ApproveFooter
          onApprove={handleOpenModal}
          totalAmount={totalAmountData?.finalTotAmount || 0}
          onCancel={handleBack}
          onPricingBreakdown={handlePriceBreakdown}
        />
      </div>
      {showPriceBreakdown && totalAmountData && (
        <PriceBreakdown
          onClose={() => setShowPriceBreakdown(false)}
          total={totalAmountData}
          isOpen={showPriceBreakdown}
        />
      )}
    </div>
  );
};

export default ApproveTabMobile;
